/* purewave.js — behaviour for the PureWave landing sections.
   Loaded once by the hero section; every handler is idempotent and re-runs on
   shopify:section:load so the theme editor stays functional.
   No IntersectionObserver / requestAnimationFrame: throttled scroll listeners
   behave predictably inside embedded preview panes. */
(function () {
  'use strict';

  var DONE = 'pwBound';

  function each(sel, root, fn) {
    var nodes = (root || document).querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }
  function once(el) {
    if (el.dataset[DONE] === '1') return false;
    el.dataset[DONE] = '1';
    return true;
  }

  /* ------------------------------------------------ shared variant state */
  function data() {
    var tag = document.getElementById('pw-product-data');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function currentVariant() {
    var d = data();
    if (!d) return null;
    var id = document.documentElement.getAttribute('data-pw-variant') || d.currentId;
    for (var i = 0; i < d.variants.length; i++) {
      if (String(d.variants[i].id) === String(id)) return d.variants[i];
    }
    return d.variants[0] || null;
  }

  function setVariant(id) {
    var d = data();
    if (!d) return;
    document.documentElement.setAttribute('data-pw-variant', String(id));
    var v = currentVariant();
    if (!v) return;
    each('[data-pw-price]', document, function (el) { el.textContent = v.price; });
    each('[data-pw-compare]', document, function (el) { el.textContent = v.compare || ''; });
    each('[data-pw-save]', document, function (el) { el.textContent = v.save || ''; });
    each('[data-pw-atc]', document, function (el) {
      el.setAttribute('data-variant-id', String(v.id));
      var label = el.querySelector('[data-pw-atc-label]');
      if (!v.available) {
        el.setAttribute('disabled', 'disabled');
        if (label) label.textContent = el.getAttribute('data-soldout-label') || 'Sold out';
      } else {
        el.removeAttribute('disabled');
        if (label) label.textContent = el.getAttribute('data-default-label') || 'Add to cart';
      }
    });
    each('[data-pw-swatch]', document, function (el) {
      el.classList.toggle('is-active', String(el.getAttribute('data-variant-id')) === String(v.id));
    });
    if (v.mediaIndex >= 0) selectMedia(v.mediaIndex);
  }

  /* ------------------------------------------------ gallery */
  function selectMedia(index) {
    var gallery = document.querySelector('[data-pw-gallery]');
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-pw-thumb]');
    if (!thumbs.length) return;
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    var main = gallery.querySelector('[data-pw-main]');
    var thumb = thumbs[index];
    if (main && thumb) {
      var src = thumb.getAttribute('data-full');
      var srcset = thumb.getAttribute('data-fullset');
      if (src && main.getAttribute('src') !== src) {
        main.classList.add('is-swapping');
        var img = new Image();
        img.onload = img.onerror = function () {
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          main.setAttribute('alt', thumb.getAttribute('data-alt') || '');
          main.classList.remove('is-swapping');
        };
        img.src = src;
      }
    }
    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.toggle('is-active', i === index);
    gallery.setAttribute('data-pw-index', String(index));
  }

  function initGallery(root) {
    each('[data-pw-gallery]', root, function (gallery) {
      if (!once(gallery)) return;
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-pw-thumb]');
        if (thumb) {
          var list = Array.prototype.slice.call(gallery.querySelectorAll('[data-pw-thumb]'));
          selectMedia(list.indexOf(thumb));
          return;
        }
        var arrow = e.target.closest('[data-pw-arrow]');
        if (arrow) {
          var cur = parseInt(gallery.getAttribute('data-pw-index') || '0', 10);
          selectMedia(cur + (arrow.getAttribute('data-pw-arrow') === 'next' ? 1 : -1));
        }
      });
    });
  }

  /* ------------------------------------------------ quantity */
  function initQty(root) {
    each('[data-pw-qty]', root, function (wrap) {
      if (!once(wrap)) return;
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pw-qty-step]');
        if (!btn || !input) return;
        e.preventDefault();
        var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-pw-qty-step'), 10);
        input.value = Math.min(99, Math.max(1, next));
        syncBundleFromQty(input.value);
      });
      if (input) {
        input.addEventListener('change', function () {
          input.value = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
          syncBundleFromQty(input.value);
        });
      }
    });
  }

  /* ------------------------------------------------ variant swatches */
  function initSwatches(root) {
    each('[data-pw-swatches]', root, function (wrap) {
      if (!once(wrap)) return;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pw-swatch]');
        if (!btn) return;
        e.preventDefault();
        setVariant(btn.getAttribute('data-variant-id'));
        var label = wrap.querySelector('[data-pw-swatch-current]');
        if (label) label.textContent = btn.getAttribute('data-value') || '';
      });
    });
  }

  /* ------------------------------------------------ buy-2 bundle tiles */
  function syncBundleFromQty(qty) {
    qty = String(qty);
    each('[data-pw-bundle]', document, function (wrap) {
      each('[data-pw-bundle-qty]', wrap, function (t) {
        var active = t.getAttribute('data-pw-bundle-qty') === qty;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function initBundle(root) {
    each('[data-pw-bundle]', root, function (wrap) {
      if (!once(wrap)) return;
      wrap.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-pw-bundle-qty]');
        if (!tile) return;
        e.preventDefault();
        var qty = parseInt(tile.getAttribute('data-pw-bundle-qty'), 10) || 1;
        var qtyInput = document.querySelector('[data-pw-qty] input');
        if (qtyInput) qtyInput.value = qty;
        syncBundleFromQty(qty);
      });
    });
  }

  /* ------------------------------------------------ add to cart */
  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.setTimeout(function () {
      var open = document.documentElement.classList.contains('js-drawer-open') ||
                 document.querySelector('.drawer--is-open, .cart-drawer.is-open, cart-drawer.active');
      if (!open) window.location.href = '/cart';
    }, 700);
  }

  function initAtc() {
    if (document.documentElement.dataset.pwAtcBound === '1') return;
    document.documentElement.dataset.pwAtcBound = '1';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pw-atc]');
      if (!btn) return;
      e.preventDefault();
      if (btn.hasAttribute('disabled') || btn.classList.contains('is-busy')) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var qtyInput = document.querySelector('[data-pw-qty] input');
      var qty = btn.hasAttribute('data-pw-qty-one') ? 1 : (parseInt(qtyInput && qtyInput.value, 10) || 1);
      var label = btn.querySelector('[data-pw-atc-label]');
      var restore = label ? label.textContent : '';
      btn.classList.add('is-busy');
      if (label) label.textContent = btn.getAttribute('data-busy-label') || 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        openCart();
      }).catch(function () {
        window.location.href = '/cart';
      }).then(function () {
        btn.classList.remove('is-busy');
        if (label) label.textContent = restore;
      });
    });
  }

  /* ------------------------------------------------ scroll-to-buy links */
  function initScrollTo() {
    if (document.documentElement.dataset.pwScrollBound === '1') return;
    document.documentElement.dataset.pwScrollBound = '1';
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pw-scroll-to-buy]');
      if (!link) return;
      var target = document.querySelector('[data-pw-buybox]');
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
      var from = window.pageYOffset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      // Some environments (reduced-motion settings, embedded preview panes) never
      // run the smooth animation; jump outright if nothing has moved.
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - from) < 2) window.scrollTo(0, top);
      }, 350);
    });
  }

  /* ------------------------------------------------ FAQ accordion */
  function initFaq(root) {
    each('[data-pw-faq]', root, function (wrap) {
      if (!once(wrap)) return;
      wrap.addEventListener('click', function (e) {
        var q = e.target.closest('[data-pw-faq-q]');
        if (!q) return;
        var panel = q.parentNode.querySelector('[data-pw-faq-a]');
        var open = q.getAttribute('aria-expanded') === 'true';
        if (!wrap.hasAttribute('data-pw-faq-multi')) {
          each('[data-pw-faq-q]', wrap, function (other) {
            if (other === q) return;
            other.setAttribute('aria-expanded', 'false');
            var p = other.parentNode.querySelector('[data-pw-faq-a]');
            if (p) p.style.maxHeight = '0px';
          });
        }
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  /* ------------------------------------------------ before / after slider */
  function initBeforeAfter(root) {
    each('[data-pw-ba]', root, function (wrap) {
      if (!once(wrap)) return;
      var after = wrap.querySelector('[data-pw-ba-after]');
      var handle = wrap.querySelector('[data-pw-ba-handle]');
      var dragging = false;

      function set(pct) {
        pct = Math.min(100, Math.max(0, pct));
        if (after) after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        if (handle) handle.style.left = pct + '%';
        wrap.setAttribute('data-pw-ba-pos', String(Math.round(pct)));
      }
      function fromEvent(e) {
        var rect = wrap.getBoundingClientRect();
        var x = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX) - rect.left;
        set((x / rect.width) * 100);
      }

      wrap.addEventListener('mousedown', function (e) { dragging = true; fromEvent(e); e.preventDefault(); });
      window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e); });
      window.addEventListener('mouseup', function () { dragging = false; });
      wrap.addEventListener('touchstart', function (e) { dragging = true; fromEvent(e); }, { passive: true });
      wrap.addEventListener('touchmove', function (e) { if (dragging) fromEvent(e); }, { passive: true });
      wrap.addEventListener('touchend', function () { dragging = false; });
      wrap.addEventListener('click', function (e) { if (!dragging) fromEvent(e); });
      if (handle) {
        handle.setAttribute('tabindex', '0');
        handle.addEventListener('keydown', function (e) {
          var pos = parseInt(wrap.getAttribute('data-pw-ba-pos') || '50', 10);
          if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); }
          if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); }
        });
      }
      set(50);
    });
  }

  /* ------------------------------------------------ sticky mobile bar */
  function initSticky() {
    var bar = document.querySelector('[data-pw-sticky]');
    var anchor = document.querySelector('[data-pw-buybox]');
    if (!bar || document.documentElement.dataset.pwStickyBound === '1') return;
    document.documentElement.dataset.pwStickyBound = '1';
    var pending = false;
    function check() {
      pending = false;
      var past = true;
      if (anchor) past = anchor.getBoundingClientRect().bottom < 0;
      // Step aside at the very bottom rather than sitting on the footer's links.
      var docH = document.documentElement.scrollHeight;
      if (past && window.pageYOffset + window.innerHeight >= docH - 140) past = false;
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      window.setTimeout(check, 120);
    }, { passive: true });
    check();
  }

  /* ------------------------------------------------ delivery estimate */
  function initEta(root) {
    each('[data-pw-eta]', root, function (el) {
      if (!once(el)) return;
      var days = parseInt(el.getAttribute('data-pw-eta'), 10);
      if (isNaN(days)) return;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var slot = el.querySelector('[data-pw-eta-date]') || el;
      try {
        slot.textContent = d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
      } catch (err) {
        slot.textContent = d.toDateString();
      }
    });
  }

  /* ------------------------------------------------ boot */
  function init(root) {
    root = root || document;
    initGallery(root);
    initQty(root);
    initSwatches(root);
    initBundle(root);
    initFaq(root);
    initBeforeAfter(root);
    initEta(root);
    initAtc();
    initScrollTo();
    initSticky();
    var d = data();
    if (d) setVariant(document.documentElement.getAttribute('data-pw-variant') || d.currentId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
